/** "14 MB", "1.2 GB", matching the wording the extend guard's copy already uses. */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) {
    return '0 MB';
  }
  const mb = bytes / (1024 * 1024);
  if (mb < 1024) {
    return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`;
  }
  return `${(mb / 1024).toFixed(1)} GB`;
}

/** "just now", "2 min ago", "3 hr ago", "5 d ago" for the dry-run age. */
export function formatAge(iso: string, now: Date = new Date()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) {
    return 'unknown';
  }
  const minutes = Math.max(0, Math.round((now.getTime() - then) / 60000));
  if (minutes < 1) {
    return 'just now';
  }
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return `${hours} hr ago`;
  }
  return `${Math.round(hours / 24)} d ago`;
}

/** "1 row per order_date × website_region × product", per 02_RIGHT_PANEL_SPEC.md. */
export function describeGrain(keys: ReadonlyArray<string> | undefined): string | undefined {
  if (!keys?.length) {
    return undefined;
  }
  return `1 row per ${keys.join(' × ')}`;
}
